import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    ordenesProveedores: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    filtroOpcion: 1,
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    proveedor: null,
    incluirAnulados: false,
    ordenesInternas: false,
    numeroPresupuesto: 0,
    numeroOrdenProveedor: 0,
    usuario: null,
    sortByDescending: true,

    ordenesProveedoresSeleccionadas: [],

    rptOrdenesProveedores: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.ordenesProveedores = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.filtroOpcion = 1;
        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.proveedor = null;
        state.incluirAnulados = false;
        state.ordenesInternas = false;
        state.numeroPresupuesto = 0;
        state.numeroOrdenProveedor = 0;
        state.usuario = null;
        state.sortByDescending = true;
    
        state.ordenesProveedoresSeleccionadas = [];
    },

    'INICIALIZAR_ORDENES' (state) {
        state.ordenesProveedores = [];
    },
    'SET_ORDENES' (state, ordenesProveedores) {
        state.ordenesProveedores = ordenesProveedores.map(ordenProveedor => ({
            ...ordenProveedor,
            selected: false,
            _showDetails: false
        }));

        /* Recuperamos la lista de ordenes seleccionadas */
        if (state.ordenesProveedoresSeleccionadas) {
            state.ordenesProveedores.forEach(ordenProveedor => {
                let ordenSelected = state.ordenesProveedoresSeleccionadas.find(t => t.ordenProveedorId == ordenProveedor.id);
                if (ordenSelected) {
                    ordenProveedor.selected = true;
                }
            });
        }
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
    'UPDATE_SELECCION_ORDEN'(state, params) {
        let selectedKey = state.ordenesProveedoresSeleccionadas.findIndex(t => t.ordenProveedorId == params.ordenProveedorId);
        if ((/true/i).test(params.seleccionar)) {
            if (selectedKey == -1) {
                state.ordenesProveedoresSeleccionadas.push({
                    ordenProveedorId: params.ordenProveedorId
                })

                let ordenProveedor = state.ordenesProveedores.find(t => t.id == params.ordenProveedorId);
                if (ordenProveedor) {
                    ordenProveedor.selected = true;
                }
            }
        } else {
            if (selectedKey != -1) {
                state.ordenesProveedoresSeleccionadas.splice(selectedKey, 1);

                let ordenProveedor = state.ordenesProveedores.find(t => t.id == params.ordenProveedorId);
                if (ordenProveedor) {
                    ordenProveedor.selected = false;
                }
            }
        }
    },
    'CLEAR_SELECTED'(state) {
        state.ordenesProveedoresSeleccionadas = [];
        /* Actualizamos la lista de ordenes */
        state.ordenesProveedores.filter(t => t.selected).forEach(ordenProveedor => {
            ordenProveedor.selected = false;
        })
    },

    'INICIALIZAR_RPT_ORDENES_PROVEEDORES' (state) {
        state.rptOrdenesProveedores = [];
    },
    'SET_RPT_ORDENES_PROVEEDORES' (state, rptOrdenesProveedores) {
        state.rptOrdenesProveedores = rptOrdenesProveedores;
    },
};

const getters = {
    getField,

    rptOrdenesProveedores (state) {
        return state.rptOrdenesProveedores;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getOrdenes ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDENES');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (parseInt(state.filtroOpcion) == 1) {
                queryString += '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&sortByDescending='+ state.sortByDescending;
            
                if (state.proveedor) {
                    if (state.proveedor.id != 0) {
                        queryString += '&proveedorId=' + state.proveedor.id;
                    }
                }
                if (state.usuario) {
                    if (state.usuario.id != 0) {
                        queryString += '&usuarioId=' + state.usuario.id;
                    }
                }
                if ((/true/i).test(state.incluirAnulados)) {
                    queryString += '&incluirAnulados=true';
                }
                if ((/true/i).test(state.ordenesInternas)) {
                    queryString += '&ordenesInternas=true';
                }
            }

            if (parseInt(state.filtroOpcion) == 2) {
                let numeroPresupuesto = -1;
                if (state.numeroPresupuesto) {
                    if (state.numeroPresupuesto != 0) {
                        numeroPresupuesto = state.numeroPresupuesto;
                    }
                }
                queryString += '&numeroPresupuesto=' + numeroPresupuesto;
            }

            if (parseInt(state.filtroOpcion) == 3) {
                let numeroOrdenProveedor = -1;
                if (state.numeroOrdenProveedor) {
                    if (state.numeroOrdenProveedor != 0) {
                        numeroOrdenProveedor = state.numeroOrdenProveedor;
                    }
                }
                queryString += '&numeroOrdenProveedor=' + numeroOrdenProveedor;
            }
            
            apiAxios.get('ordenesproveedores' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_ORDENES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, ordenProveedorId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`ordenesproveedores/${ordenProveedorId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarSaldo ( {}, ordenProveedorId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`ordenesproveedores/${ordenProveedorId}/cancelar-saldo`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    // setNoEvaluar ( {}, params ) {
    //     return new Promise((resolve, reject) => {
    //         let observaciones = {
    //             observaciones: params.observaciones
    //         }
    //         apiAxios.post('ordenesproveedores/' + params.ordenProveedorId + '/no-evaluar', observaciones)
    //             .then(() => resolve())
    //             .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //     })
    // },
    updateSeleccionOrden ( { commit }, params ) {
        commit('UPDATE_SELECCION_ORDEN', params);
    },
    clearSelected ( { commit } ) {
        commit('CLEAR_SELECTED');
    },
    actualizarStock ( {}, ordenProveedorId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`ordenesproveedores/${ordenProveedorId}/stock`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptOrdenesPendientes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_ORDENES_PROVEEDORES');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            if (params.proveedorId) {
                if (params.proveedorId != 0) {
                    queryString += '&proveedorId=' + params.proveedorId;
                }
            }
                    
            apiAxios.get('ordenesproveedores/rpt/pendientes' + queryString)
                .then(res => {
                    commit('SET_RPT_ORDENES_PROVEEDORES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    sendOrdenByEmail ( {}, params ) {
        return new Promise((resolve, reject) => {
            let file = new File([params.blob], 'orden.pdf');
            let formData = new FormData();
            formData.append('file', file);
            formData.append('email', params.email);
            formData.append('asunto', params.asunto);
            if (params.mensaje) {
                if (params.mensaje.trim() != '') {
                    formData.append('mensaje', params.mensaje);
                }
            }

            let options = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

            apiAxios.post(`ordenesproveedores/${params.ordenProveedorId}/send-email`, formData, options)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }	
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}